'use client';
import * as React from 'react';
const MotionBehaviourContext = React.createContext(undefined);
export const MotionBehaviourProvider = MotionBehaviourContext.Provider;
export const useMotionBehaviourContext = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(MotionBehaviourContext)) !== null && _React_useContext !== void 0 ? _React_useContext : 'default';
};
